import React, {useEffect, useState} from 'react';
import styled from 'styled-components/native';
import {View, Platform, Image, StyleSheet, ScrollView, Dimensions} from 'react-native';
import constants from '../constants/constants';
import * as Device from 'expo-device';
import LogoBox from './LogoBox';
import colors from '../constants/colors';

const Container = styled(ScrollView)`
  ${({isDesktop}) => {
    if (isDesktop) {
  		return `
 		 	display: flex;
  			flex-grow: 1;
			max-height: ${Dimensions.get('window').height - constants.heightReduce}px;
  		`;
  	}
  	
  	return `
  			display: flex;
  			flex-grow: 1;
  			background: ${colors.app.white};
  	`;
  	}}
`;

export default function Partnerships() {
	const [deviceType, setDeviceType] = useState<Device.DeviceType | false>(
		false,
	);

	useEffect(() => {
		const getDeviceType = async () => {
			const type = await Device.getDeviceTypeAsync();
			setDeviceType(type);
		};

		getDeviceType();
	});

  return (
    <Container isDesktop={deviceType == Device.DeviceType.DESKTOP}>
	  <LogoBox />
    </Container>
  );
}
